<template>
	<div class="date-picker" @click="showDateRangeHandler">
		<mc-input ref="input"
		          suffix="calendar"
		          v-model="dateRadioDisplay"
		          :readonly="true"
		          @blur="blurHandler"
		          :tips="tips"
		          :disabled="disabled"
		          :placeholder="placeholder">

		</mc-input>
		<date-dropdown>
			<div :ref="refName">
			<date-radio v-if="type==='date'"
						ref="dateRadio"
						:startLock="startLock"
						v-on:getDate="dateChangeHandler"
						:dateParam="dateRadioParam"
						:display="dateRadioDisplay"
						:dateBoxRegion="dateRadioShow"></date-radio>
			</div>
			<date-range v-if="type==='range'"
			            ref="dateRadio"
						:startLock="startLock"
			            v-on:getDate="dateChangeHandler"
			            :dateParam="dateRadioParam"
			            :display="dateRadioDisplay"
			            :dateBoxRegion="dateRadioShow"></date-range>
		</date-dropdown>
	</div>
</template>

<script>
    // import dateRadio from './date/radio';
    import dateRadio from './date';
    import dateRange from './radio';

    import dateDropdown from './addr-dropdown'
    import validator from '../../mixins/validator';

    export default {
        name: "date-picker",
        components: {
            dateRadio, dateDropdown, dateRange
        },
        mixins: [validator],
        inject: {
            messageBox: {
                default: ''
            }
        },
        props: {
            startLock: {
              type: Boolean,
				default: false
			},
            placeholder: {
                type: String,
                default: '选择日期'
            },
            start: {
                type: String,
                default: '2016-01-01'
            },
            end: {
                type: String,
                default: '2070-12-30'
            },
            type: {
                type: String,
                default: 'date'     //可选值： date、range
            },
	        value: {
				type: String,
		        default: ''
	        },
            disabled: {
                type: Boolean,
	            default: false
            },
            tips: String,
            refName: [String, Number]
        },
        data() {
            return {
                dateRadioDate: '',
                dateRadioParam: {
                    start: '',
                    end: '',
                    lastSub: true,
                    mold: 'white'
                },
                dateRadioDisplay: this.value,
                dateRadioShow: false,   //时间控件开始
                DOM: null
            }
        },
        computed: {},
        watch: {
            dateRadioDisplay(val) {
                this.$emit('input', val)
            },
	        value(val){
                this.dateRadioDisplay = val;
	        }
        },
        mounted() {
            this.DOM = this.$el;
            this.dateRadioParam.start = this.start;
            this.dateRadioParam.end = this.end;
        },
        methods: {
            scrolling() {
                if (this.dateRadioShow) {
                    this.$refs.dateRadio.closeDate()
                }

            },
            showDateRangeHandler() {
                if(this.disabled) {
                    return false
                }
                if (this.messageBox) {
                    this.messageBox.$refs.scrollBox.onscroll = this.scrolling;
                }

                let rect = this.DOM.getBoundingClientRect();
                let top = rect.top;
                let left = rect.left;
                let bottom = rect.bottom;

                let height = 373;
                let windowHeight = document.body.clientHeight;

                let bottomHeight = windowHeight - bottom;
                let topY = top - height;
                this.dateRadioParam.left = left;

                if (bottomHeight < height) {
                    this.dateRadioParam.top = topY;
                } else {
                    this.dateRadioParam.top = bottom;
                }
                this.dateRadioShow = true;


            },
            blurHandler(event) {
                this.$emit('blur', event);
            },
            dateChangeHandler(val) {
                this.dateRadioDisplay = val;
                this.dateRadioShow = false;
                this.$nextTick(() => {
                    this.validate('change', [val]);
                });
            }
        },

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/datepicker/datePicker.vue